import { FormattedMessage, useIntl } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const UnlimitedIssues = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraSoftwarePricingPageTemplate.modalContents.UnlimitedIssues.header",
            defaultMessage: "Unlimited issues"
        }),
        body: intl.formatMessage({
            id: "JiraSoftwarePricingPage.modalContents.UnlimitedIssues.body",
            defaultMessage:
                "In Jira, teams use issues to track individual pieces of work that must be completed. Depending on how your team uses Jira, an issue could represent a project task, a helpdesk ticket, a leave request form, etc."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <div>
                <p>{messages.body}</p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.UnlimitedIssues.cta"
                    defaultMessage="<a>Learn more</a> about issues."
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="jiraSoftware"
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                href={useLocalizedHref(
                                    "/software/jira/guides/issues/overview#what-is-an-issue"
                                )}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </div>
        </>
    );
};

export default UnlimitedIssues;
